export const GET_RECORDING_DATA_REQUEST = 'GET_RECORDING_DATA_REQUEST';
export const GET_RECORDING_DATA_SUCCESS = 'GET_RECORDING_DATA_SUCCESS';
export const GET_RECORDING_DATA_FAILURE = 'GET_RECORDING_DATA_FAILURE';

export const LOAD_RECORDING_IMAGES_REQUEST = 'LOAD_RECORDING_IMAGES_REQUEST';
export const LOAD_RECORDING_IMAGES_SUCCESS = 'LOAD_RECORDING_IMAGES_SUCCESS';

export const getRecordingDataRequest = (recordingInputUrl) => ({
  type: GET_RECORDING_DATA_REQUEST,
  params: {
    recordingInputUrl,
  },
});

export const getRecordingDataSuccess = (recordingData) => ({
  type: GET_RECORDING_DATA_SUCCESS,
  payload: {
    recordingData,
  },
});

export const getRecordingDataFailure = (error) => ({
  type: GET_RECORDING_DATA_FAILURE,
  payload: {
    error,
  },
});

export const loadRecordingImagesRequest = (recordingData) => ({
  type: LOAD_RECORDING_IMAGES_REQUEST,
  params: {
    recordingData,
  },
});

export const loadRecordingImagesSuccess = (recordingData) => ({
  type: LOAD_RECORDING_IMAGES_SUCCESS,
  payload: {
    recordingData,
  },
});
